/* eslint-disable */
import * as Types from '../schema/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const CreateOrUpdateWhiteLabelGeneralInformationDocument = gql`
    mutation CreateOrUpdateWhiteLabelGeneralInformation($input: WhiteLabelGeneralInformationTypeInput!) {
  createOrUpdateWhiteLabelGeneralInformation(input: $input) {
    id
  }
}
    `;
export type CreateOrUpdateWhiteLabelGeneralInformationMutationFn = Apollo.MutationFunction<CreateOrUpdateWhiteLabelGeneralInformationMutation, CreateOrUpdateWhiteLabelGeneralInformationMutationVariables>;

/**
 * __useCreateOrUpdateWhiteLabelGeneralInformationMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateWhiteLabelGeneralInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateWhiteLabelGeneralInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateWhiteLabelGeneralInformationMutation, { data, loading, error }] = useCreateOrUpdateWhiteLabelGeneralInformationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateWhiteLabelGeneralInformationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateWhiteLabelGeneralInformationMutation, CreateOrUpdateWhiteLabelGeneralInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateWhiteLabelGeneralInformationMutation, CreateOrUpdateWhiteLabelGeneralInformationMutationVariables>(CreateOrUpdateWhiteLabelGeneralInformationDocument, options);
      }
export type CreateOrUpdateWhiteLabelGeneralInformationMutationHookResult = ReturnType<typeof useCreateOrUpdateWhiteLabelGeneralInformationMutation>;
export type CreateOrUpdateWhiteLabelGeneralInformationMutationResult = Apollo.MutationResult<CreateOrUpdateWhiteLabelGeneralInformationMutation>;
export type CreateOrUpdateWhiteLabelGeneralInformationMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateWhiteLabelGeneralInformationMutation, CreateOrUpdateWhiteLabelGeneralInformationMutationVariables>;
export const CreateOrUpdateWhiteLabelSeoSettingsDocument = gql`
    mutation CreateOrUpdateWhiteLabelSEOSettings($input: WhiteLabelSEOSettingsTypeInput) {
  createOrUpdateWhiteLabelSEOSettings(input: $input) {
    id
  }
}
    `;
export type CreateOrUpdateWhiteLabelSeoSettingsMutationFn = Apollo.MutationFunction<CreateOrUpdateWhiteLabelSeoSettingsMutation, CreateOrUpdateWhiteLabelSeoSettingsMutationVariables>;

/**
 * __useCreateOrUpdateWhiteLabelSeoSettingsMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateWhiteLabelSeoSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateWhiteLabelSeoSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateWhiteLabelSeoSettingsMutation, { data, loading, error }] = useCreateOrUpdateWhiteLabelSeoSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateWhiteLabelSeoSettingsMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateWhiteLabelSeoSettingsMutation, CreateOrUpdateWhiteLabelSeoSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateWhiteLabelSeoSettingsMutation, CreateOrUpdateWhiteLabelSeoSettingsMutationVariables>(CreateOrUpdateWhiteLabelSeoSettingsDocument, options);
      }
export type CreateOrUpdateWhiteLabelSeoSettingsMutationHookResult = ReturnType<typeof useCreateOrUpdateWhiteLabelSeoSettingsMutation>;
export type CreateOrUpdateWhiteLabelSeoSettingsMutationResult = Apollo.MutationResult<CreateOrUpdateWhiteLabelSeoSettingsMutation>;
export type CreateOrUpdateWhiteLabelSeoSettingsMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateWhiteLabelSeoSettingsMutation, CreateOrUpdateWhiteLabelSeoSettingsMutationVariables>;
export const CreateOrUpdateWhiteLabelSocialLinksDocument = gql`
    mutation CreateOrUpdateWhiteLabelSocialLinks($input: WhiteLabelSocialLinksTypeInput) {
  createOrUpdateWhiteLabelSocialLinks(input: $input) {
    id
  }
}
    `;
export type CreateOrUpdateWhiteLabelSocialLinksMutationFn = Apollo.MutationFunction<CreateOrUpdateWhiteLabelSocialLinksMutation, CreateOrUpdateWhiteLabelSocialLinksMutationVariables>;

/**
 * __useCreateOrUpdateWhiteLabelSocialLinksMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateWhiteLabelSocialLinksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateWhiteLabelSocialLinksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateWhiteLabelSocialLinksMutation, { data, loading, error }] = useCreateOrUpdateWhiteLabelSocialLinksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateWhiteLabelSocialLinksMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateWhiteLabelSocialLinksMutation, CreateOrUpdateWhiteLabelSocialLinksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateWhiteLabelSocialLinksMutation, CreateOrUpdateWhiteLabelSocialLinksMutationVariables>(CreateOrUpdateWhiteLabelSocialLinksDocument, options);
      }
export type CreateOrUpdateWhiteLabelSocialLinksMutationHookResult = ReturnType<typeof useCreateOrUpdateWhiteLabelSocialLinksMutation>;
export type CreateOrUpdateWhiteLabelSocialLinksMutationResult = Apollo.MutationResult<CreateOrUpdateWhiteLabelSocialLinksMutation>;
export type CreateOrUpdateWhiteLabelSocialLinksMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateWhiteLabelSocialLinksMutation, CreateOrUpdateWhiteLabelSocialLinksMutationVariables>;
export const CreateOrUpdateWhiteLabelProjectMediaDocument = gql`
    mutation CreateOrUpdateWhiteLabelProjectMedia($input: WhiteLabelProjectMediaTypeInput!) {
  createOrUpdateWhiteLabelProjectMedia(input: $input) {
    id
  }
}
    `;
export type CreateOrUpdateWhiteLabelProjectMediaMutationFn = Apollo.MutationFunction<CreateOrUpdateWhiteLabelProjectMediaMutation, CreateOrUpdateWhiteLabelProjectMediaMutationVariables>;

/**
 * __useCreateOrUpdateWhiteLabelProjectMediaMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateWhiteLabelProjectMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateWhiteLabelProjectMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateWhiteLabelProjectMediaMutation, { data, loading, error }] = useCreateOrUpdateWhiteLabelProjectMediaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateWhiteLabelProjectMediaMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateWhiteLabelProjectMediaMutation, CreateOrUpdateWhiteLabelProjectMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateWhiteLabelProjectMediaMutation, CreateOrUpdateWhiteLabelProjectMediaMutationVariables>(CreateOrUpdateWhiteLabelProjectMediaDocument, options);
      }
export type CreateOrUpdateWhiteLabelProjectMediaMutationHookResult = ReturnType<typeof useCreateOrUpdateWhiteLabelProjectMediaMutation>;
export type CreateOrUpdateWhiteLabelProjectMediaMutationResult = Apollo.MutationResult<CreateOrUpdateWhiteLabelProjectMediaMutation>;
export type CreateOrUpdateWhiteLabelProjectMediaMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateWhiteLabelProjectMediaMutation, CreateOrUpdateWhiteLabelProjectMediaMutationVariables>;
export const OrganizerWhiteLabelDocument = gql`
    query OrganizerWhiteLabel {
  organizer {
    id
    whiteLabel {
      id
      projectName
      domain
      domainStatus
      domainType
      whiteLabelConfig {
        id
        metaTitle
        metaDescription
        keywords
        instagramLink
        facebookLink
        twitterLink
        youtubeLink
        linkedIn
        tikTok
        buttonColor
        showNewEvents
        showUpcomingEvents
        showPopularPerformers
        whiteLabelBannerImages {
          id
          path
          link
          fileName
        }
        favicon {
          id
          path
          link
          fileName
        }
        siteLogo {
          id
          path
          link
          fileName
        }
      }
    }
    whiteLabelLimitInfo {
      activeCount
      limit
      limitReached
    }
  }
}
    `;

/**
 * __useOrganizerWhiteLabelQuery__
 *
 * To run a query within a React component, call `useOrganizerWhiteLabelQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizerWhiteLabelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizerWhiteLabelQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizerWhiteLabelQuery(baseOptions?: Apollo.QueryHookOptions<OrganizerWhiteLabelQuery, OrganizerWhiteLabelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizerWhiteLabelQuery, OrganizerWhiteLabelQueryVariables>(OrganizerWhiteLabelDocument, options);
      }
export function useOrganizerWhiteLabelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizerWhiteLabelQuery, OrganizerWhiteLabelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizerWhiteLabelQuery, OrganizerWhiteLabelQueryVariables>(OrganizerWhiteLabelDocument, options);
        }
export function useOrganizerWhiteLabelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizerWhiteLabelQuery, OrganizerWhiteLabelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizerWhiteLabelQuery, OrganizerWhiteLabelQueryVariables>(OrganizerWhiteLabelDocument, options);
        }
export type OrganizerWhiteLabelQueryHookResult = ReturnType<typeof useOrganizerWhiteLabelQuery>;
export type OrganizerWhiteLabelLazyQueryHookResult = ReturnType<typeof useOrganizerWhiteLabelLazyQuery>;
export type OrganizerWhiteLabelSuspenseQueryHookResult = ReturnType<typeof useOrganizerWhiteLabelSuspenseQuery>;
export type OrganizerWhiteLabelQueryResult = Apollo.QueryResult<OrganizerWhiteLabelQuery, OrganizerWhiteLabelQueryVariables>;
export const CreateOrUpdateWhiteLabelDomainDocument = gql`
    mutation CreateOrUpdateWhiteLabelDomain($domainType: DomainType!, $domain: String, $whiteLabelId: Int!) {
  createOrUpdateWhiteLabelDomain(
    domainType: $domainType
    domain: $domain
    whiteLabelId: $whiteLabelId
  ) {
    id
  }
}
    `;
export type CreateOrUpdateWhiteLabelDomainMutationFn = Apollo.MutationFunction<CreateOrUpdateWhiteLabelDomainMutation, CreateOrUpdateWhiteLabelDomainMutationVariables>;

/**
 * __useCreateOrUpdateWhiteLabelDomainMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateWhiteLabelDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateWhiteLabelDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateWhiteLabelDomainMutation, { data, loading, error }] = useCreateOrUpdateWhiteLabelDomainMutation({
 *   variables: {
 *      domainType: // value for 'domainType'
 *      domain: // value for 'domain'
 *      whiteLabelId: // value for 'whiteLabelId'
 *   },
 * });
 */
export function useCreateOrUpdateWhiteLabelDomainMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateWhiteLabelDomainMutation, CreateOrUpdateWhiteLabelDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateWhiteLabelDomainMutation, CreateOrUpdateWhiteLabelDomainMutationVariables>(CreateOrUpdateWhiteLabelDomainDocument, options);
      }
export type CreateOrUpdateWhiteLabelDomainMutationHookResult = ReturnType<typeof useCreateOrUpdateWhiteLabelDomainMutation>;
export type CreateOrUpdateWhiteLabelDomainMutationResult = Apollo.MutationResult<CreateOrUpdateWhiteLabelDomainMutation>;
export type CreateOrUpdateWhiteLabelDomainMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateWhiteLabelDomainMutation, CreateOrUpdateWhiteLabelDomainMutationVariables>;
export const RetryWhiteLabelDomainSetupDocument = gql`
    mutation RetryWhiteLabelDomainSetup($whiteLabelId: Int!) {
  retryWhiteLabelDomainSetup(whiteLabelId: $whiteLabelId) {
    id
  }
}
    `;
export type RetryWhiteLabelDomainSetupMutationFn = Apollo.MutationFunction<RetryWhiteLabelDomainSetupMutation, RetryWhiteLabelDomainSetupMutationVariables>;

/**
 * __useRetryWhiteLabelDomainSetupMutation__
 *
 * To run a mutation, you first call `useRetryWhiteLabelDomainSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryWhiteLabelDomainSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryWhiteLabelDomainSetupMutation, { data, loading, error }] = useRetryWhiteLabelDomainSetupMutation({
 *   variables: {
 *      whiteLabelId: // value for 'whiteLabelId'
 *   },
 * });
 */
export function useRetryWhiteLabelDomainSetupMutation(baseOptions?: Apollo.MutationHookOptions<RetryWhiteLabelDomainSetupMutation, RetryWhiteLabelDomainSetupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryWhiteLabelDomainSetupMutation, RetryWhiteLabelDomainSetupMutationVariables>(RetryWhiteLabelDomainSetupDocument, options);
      }
export type RetryWhiteLabelDomainSetupMutationHookResult = ReturnType<typeof useRetryWhiteLabelDomainSetupMutation>;
export type RetryWhiteLabelDomainSetupMutationResult = Apollo.MutationResult<RetryWhiteLabelDomainSetupMutation>;
export type RetryWhiteLabelDomainSetupMutationOptions = Apollo.BaseMutationOptions<RetryWhiteLabelDomainSetupMutation, RetryWhiteLabelDomainSetupMutationVariables>;
export type CreateOrUpdateWhiteLabelGeneralInformationMutationVariables = Types.Exact<{
  input: Types.WhiteLabelGeneralInformationTypeInput;
}>;


export type CreateOrUpdateWhiteLabelGeneralInformationMutation = { __typename?: 'Mutation', createOrUpdateWhiteLabelGeneralInformation: { __typename?: 'WhiteLabelProxyType', id: number } };

export type CreateOrUpdateWhiteLabelSeoSettingsMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.WhiteLabelSeoSettingsTypeInput>;
}>;


export type CreateOrUpdateWhiteLabelSeoSettingsMutation = { __typename?: 'Mutation', createOrUpdateWhiteLabelSEOSettings: { __typename?: 'WhiteLabelConfigProxyType', id: number } };

export type CreateOrUpdateWhiteLabelSocialLinksMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.WhiteLabelSocialLinksTypeInput>;
}>;


export type CreateOrUpdateWhiteLabelSocialLinksMutation = { __typename?: 'Mutation', createOrUpdateWhiteLabelSocialLinks: { __typename?: 'WhiteLabelConfigProxyType', id: number } };

export type CreateOrUpdateWhiteLabelProjectMediaMutationVariables = Types.Exact<{
  input: Types.WhiteLabelProjectMediaTypeInput;
}>;


export type CreateOrUpdateWhiteLabelProjectMediaMutation = { __typename?: 'Mutation', createOrUpdateWhiteLabelProjectMedia: { __typename?: 'WhiteLabelConfigProxyType', id: number } };

export type OrganizerWhiteLabelQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OrganizerWhiteLabelQuery = { __typename?: 'Query', organizer: { __typename?: 'OrganizerProxyType', id: number, whiteLabel?: { __typename?: 'WhiteLabelProxyType', id: number, projectName?: string | null, domain?: string | null, domainStatus?: Types.DomainStatus | null, domainType?: Types.DomainType | null, whiteLabelConfig?: { __typename?: 'WhiteLabelConfigProxyType', id: number, metaTitle?: string | null, metaDescription?: string | null, keywords?: string | null, instagramLink?: string | null, facebookLink?: string | null, twitterLink?: string | null, youtubeLink?: string | null, linkedIn?: string | null, tikTok?: string | null, buttonColor?: string | null, showNewEvents: boolean, showUpcomingEvents: boolean, showPopularPerformers: boolean, whiteLabelBannerImages: Array<{ __typename?: 'WhiteLabelBannerImageProxyType', id: number, path?: string | null, link: string, fileName?: string | null }>, favicon?: { __typename?: 'ImageProxyType', id: number, path: string, link: string, fileName: string } | null, siteLogo?: { __typename?: 'ImageProxyType', id: number, path: string, link: string, fileName: string } | null } | null } | null, whiteLabelLimitInfo: { __typename?: 'WhiteLabelLimitInfoType', activeCount: number, limit?: number | null, limitReached: boolean } } };

export type CreateOrUpdateWhiteLabelDomainMutationVariables = Types.Exact<{
  domainType: Types.DomainType;
  domain?: Types.InputMaybe<Types.Scalars['String']['input']>;
  whiteLabelId: Types.Scalars['Int']['input'];
}>;


export type CreateOrUpdateWhiteLabelDomainMutation = { __typename?: 'Mutation', createOrUpdateWhiteLabelDomain: { __typename?: 'WhiteLabelProxyType', id: number } };

export type RetryWhiteLabelDomainSetupMutationVariables = Types.Exact<{
  whiteLabelId: Types.Scalars['Int']['input'];
}>;


export type RetryWhiteLabelDomainSetupMutation = { __typename?: 'Mutation', retryWhiteLabelDomainSetup: { __typename?: 'WhiteLabelProxyType', id: number } };
